<template>
  <PageLayout>
    <h2 class="text-h3 font-weight-bold pb-4">
      Nastavení
    </h2>
    <v-tabs background-color="transparent" class="c-tabs mb-6">
      <v-tab v-for="(tab, index) in tabs" :key="index" :to="tab.route">
        {{ tab.text }}
      </v-tab>
    </v-tabs>
    <router-view />
  </PageLayout>
</template>

<script>
import PageLayout from "@/components/page/home/PageLayout"
import settingsRoutes from "@/router/settings"

export default {
  components: {
    PageLayout,
  },
  computed: {
    tabs() {
      return settingsRoutes
        .filter(route => typeof route.redirect === "undefined")
        .map(route => ({
          text: route.meta?.title,
          route: `/settings/${route.path}`,
        }))
    },
  },
}
</script>
